import { render } from "./page-adopt-type.vue?vue&type=template&id=4bea722b"
import script from "./page-adopt-type.vue?vue&type=script&lang=js"
export * from "./page-adopt-type.vue?vue&type=script&lang=js"
script.render = render

export default script